var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Down",
    "data-name": "Arrow / Down",
    transform: "translate(-0.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1169",
    "data-name": "Rect\\xE1ngulo 1169",
    width: 16,
    height: 16,
    transform: "translate(0.453)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1091",
    "data-name": "Trazado 1091",
    d: "M6.5,8a1.285,1.285,0,0,1-.923-.4L.378,2.272a1.356,1.356,0,0,1,0-1.878,1.278,1.278,0,0,1,1.846,0L6.5,4.776,10.776.394a1.278,1.278,0,0,1,1.846,0,1.356,1.356,0,0,1,0,1.878L7.423,7.6A1.285,1.285,0,0,1,6.5,8Z",
    transform: "translate(1.912 4)",
    fill: "#ec0000",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/ic_arrowDown.9bc938b4188193fec46564ba8b4ae40a.svg";
export { ForwardRef as ReactComponent };